import * as angular from 'angular';
import * as moment from 'moment';
import {ShopActivity} from "../../models/activity/shopActivity";
import GobActivity from "../../models/activity/gobActivity";
import {apsEnums} from "../../shared/dto/aps.enums";
import {Strings} from "../../shared/config/constant.module";
import template from './qualificationHistory.tpl.html';

export interface QualificationHistoryData {
  activity: ShopActivity;
  gob: GobActivity;
  location: apsEnums.Location;
  timeZone: string;
  isAuthorizedForRequalification: boolean;
}

export function openQualificationHistory(data: QualificationHistoryData,
                                         $modal: mm.foundation.modal): angular.IPromise<string> {
  return $modal.open({
    template: template,
    controller: 'QualificationHistoryCtrl as historyCtrl',
    resolve: {
      data: function() {
        return data;
      }
    }
  }).result;
}

export default angular
  .module('aps.controller.qualificationHistory', [])
  .controller('QualificationHistoryCtrl', qualificationHistoryCtrl)
  .name;

function qualificationHistoryCtrl(
  $modalInstance: mm.foundation.modalInstance,
  data: QualificationHistoryData
) {
  let vm = this;
  vm.gob = data.gob;
  vm.section = vm.gob.section;
  vm.location = data.location;
  vm.locationName = vm.location === apsEnums.Location.HotEnd ? 'Hot End' : 'Cold End';
  if (vm.location === apsEnums.Location.HotEnd) {
    vm.history = vm.gob.qualificationHistory.heQualifications();
  } else {
    vm.history = vm.gob.qualificationHistory.ceQualifications();
  }
  vm.timeZone = data.timeZone;

  vm.formatTime = (time) => {
    return moment.utc(time).tz(vm.timeZone).format(Strings.TIME_FORMAT);
  };

  vm.close = () => {
    $modalInstance.close();
  };

  vm.canAddRequalification = data.isAuthorizedForRequalification;

  vm.addRequalification = () => {
    $modalInstance.close('add');
  };
}


// WEBPACK FOOTER //
// ./src/app/controllers/toolHistory/qualificationHistory.ts